const SvgStrongNo = (props) => (
  <svg
    width="19"
    height="18"
    viewBox="0 0 19 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.75 9H12.75M17.25 9C17.25 13.1421 13.8921 16.5 9.75 16.5C5.60786 16.5 2.25 13.1421 2.25 9C2.25 4.85786 5.60786 1.5 9.75 1.5C13.8921 1.5 17.25 4.85786 17.25 9Z"
      style={{ fill: 'var(--kula-colors-white, #FFFFFF)' }}
      stroke="currentColor"
      strokeWidth={1.2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgStrongNo;
